import { render, staticRenderFns } from "./StartupEditLocation.vue?vue&type=template&id=4fdec418&scoped=true"
import script from "./StartupEditLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./StartupEditLocation.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdec418",
  null
  
)

export default component.exports